<script lang="ts">
import { useDesignStore } from '@/stores/designStore.ts'
import { BButton } from 'bootstrap-vue-next'
import { ref } from 'vue'

export default {
  props: ['val1', 'val2'],
  setup(props) {
    const designStore = useDesignStore()
    let toggle = ref(false)
    return { props, toggle, designStore }
  },
  components: {
    BButton
  }
}
</script>
<template>
  <BButton
    class="buttonStyle hoverablePrimary"
    :style="{
      background: designStore.primaryTheme,
      color: designStore.primaryText,
      borderColor: designStore.secondaryTheme
    }"
    @click="toggle = !toggle"
    >{{ toggle ? val1 : val2 }}
    <i
      style="font-size: x-small; position: relative; bottom: 0.1rem"
      v-if="!toggle"
      class="bi bi-asterisk"
    ></i
  ></BButton>
</template>
<style scoped>
.buttonStyle {
  border: 2px solid;
  padding: 0.35rem;
  border-radius: 1rem;
  cursor: pointer;
  margin-left: 0.25rem;
  white-space: nowrap;
  display: inline-block;
}
</style>
